import { render, staticRenderFns } from "./RegistrationChecklistItemEdit.vue?vue&type=template&id=0ad1885a&scoped=true"
import script from "./RegistrationChecklistItemEdit.vue?vue&type=script&lang=js"
export * from "./RegistrationChecklistItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad1885a",
  null
  
)

export default component.exports